export enum AccessAccountsStatusDto {
  Pending = 'Pending',
  Finished = 'Finished',
}
